import { forwardRef, useState } from 'react';
import { cn } from '@/lib/utils/cn.js';

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix' | 'suffix'> {
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  error?: boolean;
  containerClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ prefix, suffix, error = false, containerClassName, className, ...rest }, ref) => {
    const [focused, setFocused] = useState(false);

    return (
      <div
        className={cn(
          'flex items-center gap-2 h-11 px-3.5 rounded-lg border bg-[var(--bg-elevated)] transition-all',
          error
            ? 'border-[var(--danger)]'
            : focused
              ? 'border-[var(--primary)] shadow-[0_0_0_3px_var(--primary-glow)]'
              : 'border-transparent',
          containerClassName,
        )}
      >
        {prefix && (
          <span className="text-[var(--text-muted)] font-semibold shrink-0">{prefix}</span>
        )}
        <input
          ref={ref}
          className={cn(
            'flex-1 bg-transparent outline-none text-[var(--text-primary)] placeholder:text-[var(--text-muted)] text-[15px] font-medium min-w-0',
            className,
          )}
          onFocus={(e) => {
            setFocused(true);
            rest.onFocus?.(e);
          }}
          onBlur={(e) => {
            setFocused(false);
            rest.onBlur?.(e);
          }}
          {...rest}
        />
        {suffix && (
          <span className="text-[var(--text-muted)] font-mono text-xs shrink-0">{suffix}</span>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';
